


// import Cookies from "js-cookie";
// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const token = Cookies.get("token");

//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }


import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../app/store";
import { isAuthSessionCurrent } from "../utils/authSession";

export default function ProtectedRoute({ roles }) {
  const { token, user, logout } = useAuth();
  const sessionExpired = Boolean(token) && !isAuthSessionCurrent();

  useEffect(() => {
    if (sessionExpired) logout();
  }, [logout, sessionExpired]);

  if (!token || sessionExpired) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;   // <-- THIS IS THE KEY
}



